import React from 'react';
import styles from './SectionTable.module.css';
import Pill from '../common/Pill';

function deployAggStatus(deployStatus) {
  if (!deployStatus?.length) return null;
  if (deployStatus.some(e => e.status === 'errored')) return 'errored';
  if (deployStatus.some(e => e.status === 'running')) return 'running';
  if (deployStatus.every(e => e.status === 'completed')) return 'completed';
  return deployStatus[0]?.status ?? null;
}

export default function RolloutCell({ deployStatus }) {
  if (!deployStatus?.length) return <span className={styles.muted}>—</span>;
  const total  = deployStatus.length;
  const done   = deployStatus.filter((d) => d.status === 'completed').length;
  const status = deployAggStatus(deployStatus);
  return (
    <Pill status={status} dot pulse={status === 'running'}>
      {done}/{total} deployed
    </Pill>
  );
}
